"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_class_component_1 = __importStar(require("vue-class-component"));
var RequestData_1 = __importDefault(require("../../classes/RequestData"));
var request_1 = __importDefault(require("../../request"));
var event_bus_1 = require("../../event-bus");
var EchoMixin_1 = __importDefault(require("./EchoMixin"));
var vue_property_decorator_1 = require("vue-property-decorator");
var ScoutsMixin = /** @class */ (function (_super) {
    __extends(ScoutsMixin, _super);
    function ScoutsMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.scouts = new RequestData_1.default();
        _this.archived = false;
        _this.currentDistrict = {};
        _this.currentUnit = {};
        return _this;
    }
    ScoutsMixin.prototype.onArchivedChanged = function () {
        this.requestScouts(1);
    };
    ScoutsMixin.prototype.created = function () {
        event_bus_1.EventBus.$on(event_bus_1.events.scout.all, this.requestScouts)
            .$on(event_bus_1.events.scout.create, this.onScoutCreate)
            .$on(event_bus_1.events.scout.update, this.onScoutUpdate)
            .$on(event_bus_1.events.scout.archive, this.onScoutArchive)
            .$on(event_bus_1.events.common.search.phrase, this.onSearchPhraseInput)
            .$on(event_bus_1.events.common.search.hit, this.requestScoutsFirstPage);
        this.echo.channel(this.echoChannels.scout)
            .listen(this.echoEvents.scout.create, this.requestScouts)
            .listen(this.echoEvents.scout.update, this.updateScout);
    };
    ScoutsMixin.prototype.beforeDestroy = function () {
        event_bus_1.EventBus.$off(event_bus_1.events.scout.all, this.requestScouts)
            .$off(event_bus_1.events.scout.create, this.onScoutCreate)
            .$off(event_bus_1.events.scout.update, this.onScoutUpdate)
            .$off(event_bus_1.events.scout.archive, this.onScoutArchive)
            .$off(event_bus_1.events.common.search.phrase, this.onSearchPhraseInput)
            .$off(event_bus_1.events.common.search.hit, this.requestScoutsFirstPage);
        this.echo.leave(this.echoChannels.scout);
    };
    ScoutsMixin.prototype.requestScouts = function (page, district_id, unit_id) {
        var _a, _b;
        return request_1.default.scout.all(this.scouts.search, this.archived, (_a = this.currentDistrict.id) !== null && _a !== void 0 ? _a : 0, (_b = this.currentUnit.id) !== null && _b !== void 0 ? _b : 0, page !== null && page !== void 0 ? page : this.scouts.pagination.current_page, this.updateScouts);
    };
    ScoutsMixin.prototype.requestScoutsFirstPage = function () {
        return this.requestScouts(1);
    };
    ScoutsMixin.prototype.onScoutCreate = function (scout) {
        return request_1.default.scout.create(scout, this.requestScouts);
    };
    ScoutsMixin.prototype.onScoutUpdate = function (data) {
        return request_1.default.scout.update(data.scout_id, data, this.updateScout);
    };
    ScoutsMixin.prototype.onScoutArchive = function (scout) {
        return request_1.default.scout.archive(scout.id, this.requestScouts);
    };
    ScoutsMixin.prototype.onSearchPhraseInput = function (search) {
        this.updateSearchPhrase(search);
    };
    ScoutsMixin.prototype.updateScouts = function (scouts, pagination) {
        this.scouts = this.scouts
            .setArray(scouts)
            .setPagination(pagination);
    };
    ScoutsMixin.prototype.updateScout = function (scout) {
        this.scouts = this.scouts.updateArray(scout);
    };
    ScoutsMixin.prototype.updateSearchPhrase = function (search) {
        this.scouts = this.scouts.setSearch(search);
    };
    ScoutsMixin.prototype.updateArchived = function (value) {
        this.archived = value;
    };
    __decorate([
        vue_property_decorator_1.Watch("archived")
    ], ScoutsMixin.prototype, "onArchivedChanged", null);
    ScoutsMixin = __decorate([
        vue_class_component_1.default
    ], ScoutsMixin);
    return ScoutsMixin;
}(vue_class_component_1.mixins(EchoMixin_1.default)));
exports.default = ScoutsMixin;
